// react-hook-form's Controller falls back to its mount-time default whenever
// the live field value is `undefined`, so tri-state boolean filters (isOnline,
// isMaintenance…) use `null` as their "All" sentinel instead. The SDK models
// still declare these fields as `boolean | undefined` — this is the single,
// intentional seam where a live `null` is widened to that type; the relevant
// `*-list-filter.controller.tsx` normalizes it back to `undefined`
// (`?? undefined`) before it reaches the actual query parameters.
export const toClearableFieldValue = (
  value: boolean | null,
): boolean | undefined => value as unknown as boolean | undefined;
